export default {
    FUNGIBLE: 'fungibleSection',
    NON_FUNGIBLE: 'nonFungibleSection'
};
